var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{key:"id",staticClass:"contact-form",attrs:{"id":"contact-form"}},[_c('hr',{key:"id0",attrs:{"size":"20"}}),_vm._v(" "),_c('h1',{key:"id1",staticClass:"contact-form_title"},[_vm._v("Contactez-nous : "),_c('a',{attrs:{"href":"mailto::ccmartigny@gmail.com"}},[_c('font',{attrs:{"color":"blue"}},[_vm._v("ccmartigny@gmail.com")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41631d04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactForm.vue
// module id = wn6v
// module chunks = 1